
export function exportCanvasAsPNG(canvasElement, fileName, isMap, imageAsset) {
    console.log(canvasElement, fileName, isMap, imageAsset);
    if (imageAsset) {
        const dlLink = document.createElement('a');
        dlLink.download = fileName.replace('.', '') + '.png';
        dlLink.href = imageAsset;
        document.body.appendChild(dlLink);
        dlLink.click();
        document.body.removeChild(dlLink);

    } else {
        const MIME_TYPE = "image/png";
        let imgURLPromise = isMap ? canvasElement.exportPng() : canvasElement.cfg.el.toDataURL(MIME_TYPE);
        imgURLPromise = Promise.resolve(imgURLPromise).then(imgURL => {
            const dlLink = document.createElement('a');
            dlLink.download = fileName.replace('.', '');
            dlLink.href = imgURL;
            dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
            document.body.appendChild(dlLink);
            dlLink.click();
            document.body.removeChild(dlLink);
        }); // promise: always a promise

    }
}


export function exportCSV(csv, fileName, isRaw) {
    if (!csv) {
        return;
    }
    let csvContent = csv;
    if (!isRaw) {
        csvContent = csv.map((e, idx) => {
            if (idx === 0) {
                const header = Object.keys(e).join(',') + '\n';
                return header + Object.values(e).join(',')
            }
            return Object.values(e).join(',');
        }).join("\n");
    }
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName.replace('.', ''));
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
